import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import DashboardEntitiesView from '@/screens/dashboard/components/dashboard-entities-view.vue'
import DashboardEntitiesLoading from '@/screens/dashboard/components/dashboard-entities-loading.vue'
import { useProfileStore } from '@/modules/profile/profile.store'

export default defineComponent({
  components: {
    DashboardEntitiesView,
    DashboardEntitiesLoading,
  },

  computed: {
    ...mapState(useProfileStore, { profile: 'data' }),
  },
})
